import React from 'react';
import MainLayout from '../components/MainLayout';
import { Link } from 'react-router-dom';
import whoweare from '../assets/images/img/who-we-are.jpg';
import carrer from '../assets/images/carrer.jpg';
import carrer_pic from '../assets/images/careers_photo.jpg';
// import joinourteam from '../assets/images/pct-Join-the-team.webp';
import Typewriter from 'typewriter-effect';
import { HashLink } from 'react-router-hash-link';
import Accordion from 'react-bootstrap/Accordion';


export default function Careers() {
  return (
    <>
    <MainLayout>

    <div className='breadcrumb_area'>
    <div className='photo'>
    <img src={whoweare} alt=''/>
      <div className='wrapper'> 
          <div className='container'>
          <div className='row'>
          <div className='col-12'>
          <h1 className='breadcrumb_title'>Careers</h1>
          <ul className="breadcrumb_list">
          <li className="breadcrumb_item"><Link to='/'>Home</Link></li>
          <li className="breadcrumb_item">Careers</li>                 
          </ul>
          </div>
          </div>
          </div>  
      </div>
    </div>
    </div>


    <div className='inner_page_content contact_us_page'> 

    <div className='bg-light mb-5 pt-3 pb-3'> 
    <div className='container'>

      <div className='row'>
      <div className='col-lg-7'>
        <h2 className='mt-3'>Careers</h2>
                  <h1 className='mt-3'>JOIN THE TEAM OF <strong className='text-primary'> PROFESSIONALS</strong> DO YOU NEED A JOB?</h1>
                  <p className='mt-3'>Start you career with an organization that promotes a healthy work-life balance. Join us today and stay ahead in your life.</p>

                <HashLink className='btn btn-primary btn-lg mt-4' to='/careers#applyforjob'>Apply</HashLink>
 
        </div>

        <div className='col-lg-5'>
            <img className='img-fluid rounded mt-3 mb-3' src={carrer_pic} alt='' />
        </div>

      </div>
      </div>

</div>
      <div className='container'>

      <div className='row'>

      <div className='col-12 mt-3 mb-3 text-center'>

      <h5>We realize that diversity makes us stronger. We are continue to work towards making our 
        efforts as diverse and inclusive as possible. We give everyone a voice and empower people, which are two 
        of the values that drive us.</h5>

      </div>
      <div className='col-12 mt-3 mb-5 text-center'>

      <div className='d-inline-flex'>
      <div><span className='Typewriter__wrapper_support'>Are You Next &nbsp; </span> </div>

      <div>
      <Typewriter
        options={{
          strings: ['Problem Solver?', 'Innovator?', 'Leader?'],
          autoStart: true,
          loop: true,
        }}
      />
      </div>

      </div>




      </div>

      {/* <div className='col-12'>
      <img className='img-fluid' src={joinourteam} alt='' />
      </div> */}

      </div>


    <div className='row'>

      <div className='col-lg-12 mb-4 mt-3 text-center'><h2>Life at PCT</h2></div>

      <div className='col-lg-12'>

      <div className='life_wrapper'>
      <div className='life_box'>
      <h4>We value a great working environment and culture  </h4>
        <p> We make every effort to make everyone feel at ease in the office, at home, and throughout the business. Benevolence, humility, and openness are essential components of how we work and engage with one another. We also believe that a healthy work-life balance encourages people to be engaged and successful in their careers.</p>

      </div>

      <div className='life_box'>
        <h4>We want you to grow this us </h4>
        <p>Working at PCT gives you the chance to be a part of the creative and fast-paced DevOps and Server Support industries. You’ll be able to advance your career, work with the best and most exciting businesses, and collaborate with colleagues from all over the world.</p>
        </div>

      </div>

      <div className='life_wrapper'>
      <div className='life_box'>
      <h4>We need you to help us grow "well"</h4>
      <p>At PCT, every teammate can make an impact on the business and the company. We encourage everyone to take initiative, share ideas and innovate. We regularly survey our peers and engage them in defining what we want our company to be for tomorrow and the role it should play in our industry and beyond.</p>

      </div>



      </div>


      </div>

    </div>
          

    <div className='row'>

        <div className='col-12 mt-4'>
          <h2 className='mb-3'>Our Open Positions</h2>

          <Accordion>

<Accordion.Item eventKey="0">
  <Accordion.Header>Digital Marketing Consultant</Accordion.Header>
  <Accordion.Body>
    
    sqsqs

  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="1">
  <Accordion.Header>Senior dotnet core developer</Accordion.Header>
  <Accordion.Body>
    
    sqsqs

  </Accordion.Body>
</Accordion.Item>



<Accordion.Item eventKey="2">
  <Accordion.Header>Devops Engineer</Accordion.Header>
  <Accordion.Body>
    
<h6>Job Description</h6>
<p>PCT is seeking a DevOps engineer to manage the global Linux infrastructure for our Database development environment . This position requires wide and overall knowledge in Linux administration, patching, virtualisation, performance analysis, performance tuning, cloud computing technologies and networking technologies. While their primary role is to support operations for the Linux/Unix and Cloud infrastructure, they will be also occasionally required to take active role in testing applications, and diagnosis of IT problems outside their scope of responsibility.</p>

<h6>Job Role: Candidate will be a key DevOps Engineer in a project team tasked with development of cloud-native and highly scalable products</h6>

<h6>What You Will Do?</h6>
<p>Candidate will be a key DevOps Engineer in a project team tasked with development of cloud-native and highly scalable products</p>
  
  <h6 className='mt-4'>What We Want</h6>
  <h6>Minimum Qualifications:</h6>
 
 <ul>
<li>3+ Years of DevOps Experience</li>
<li>Test, build, design, deployment, and ability to maintain continuous integration and continuous delivery process using tools like Jenkins, maven, Git, etc.</li>
<li>Proficient with Git and Git work-flows. Source Control version tools such as Bitbucket & Git.</li>
<li>Hands-on experience in using configuration management tools like Ansible, Puppet, etc.</li>
<li>Hands-on experience in Infrastructure Automation tools like Terraform and Ansible Hands-on experience to build and handle VM’s, Containers utilizing tools like Kubernetes , Docker, etc.</li>
<li>Hands-on experience in building, designing and maintaining public or private cloud-based applications with AWS, Azure, OpenStack</li>
<li>Expertise in operating Linux environment with good command over any scripting language such as Shell, Perl, Python , etc.</li>
<li>Expertise with server monitoring tools like Prometheous, Grafana (and derivatives)</li>
<li>Monitoring the processes during the entire lifecycle for its adherence and updating or creating new processes for improvement and minimizing the wastage</li>
<li>Encouraging and building automated processes wherever possible</li>
<li>Selecting and deploying appropriate CI/CD tools</li>
<li>Strive for continuous improvement and build continuous integration, continuous development, and constant deployment pipeline (CI/CD Pipeline)</li>
<li>Excellency in troubleshooting</li>
<li>Working knowledge of various tools, open-source technologies, and cloud services</li>
<li>Must know how to choose the best tools and technologies which best fits the business needs.</li>
<li>Ability to automate test and deploy the code and monitor.</li>
<li>Work in close coordination with the development and operations team such that the application is in line with performance according to the customer’s expectation</li>
<li>Working in regulation with industry-standard best practices in close coordination with integration and deployment team.</li>

 </ul>
  
 <HashLink className='btn btn-primary  mt-4 mb-4' to='/careers#applyforjob'>Apply</HashLink>
  </Accordion.Body>
</Accordion.Item>


<Accordion.Item eventKey="3">
  <Accordion.Header>Database management Engineer</Accordion.Header>
  <Accordion.Body>
    
    sqsqs

  </Accordion.Body>
</Accordion.Item>


      </Accordion>

        </div>


    </div>

      <div className='row mt-5' id='applyforjob'>

      <div className='col-lg-6'>

      <img className='img-fluid rounded' src={carrer} alt='' />
      </div>

      <div className='col-lg-6'>

      <div className='contact_form'>


      <div className='row'>
      <div className='col-lg-12 mb-2'>  <h2>Join our team to shape your future.</h2></div>

      <div className='col-lg-6'>
      <div className="mb-3">
      <label htmlFor="yourname" className="form-label">Your Name</label>
      <input type="text" className="form-control" id="yourname" />
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">
      <label htmlFor="youremail" className="form-label">Email address</label>
      <input type="email" className="form-control" id="youremail" />
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">
      <label htmlFor="yourmobile" className="form-label">Your mobile number</label>
      <input type="number" className="form-control" id="yourmobile" />
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">
      <label htmlFor="currentcompany" className="form-label">Current company (optional)</label>
      <input type="text" className="form-control" id="currentcompany" />
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">
      <label htmlFor="currentcompany" className="form-label">Current Salary And Expectations</label>
      <input type="text" className="form-control" id="currentcompany" />
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">     
      <label className="form-label">Select Job Profile</label>   
      <select className="form-select">
      <option>Select</option>
      <option value="CloudOps Engineer">CloudOps Engineer</option>
      <option value="DevOps Engineer">DevOps Engineer</option>
      <option value="Windows Server Admin">Windows Server Admin</option>
      <option value="Content Writer">Content Writer</option>
      <option value="SEO Executive">SEO Executive</option>
      <option value="Digital Marketing Manager">Digital Marketing Manager</option>
      <option value="Sales Executive">Sales Executive</option>
      <option value="Billing Executive">Billing Executive</option>
      <option value="Human Resources">Human Resources</option>
      <option value="Other">Other</option>
      </select>
      </div>
      </div>

      <div className='col-lg-6'>
      <div className="mb-3">     
      <label className="form-label">Select your Experience</label>   
      <select className="form-select">
      <option>Select</option>
      <option value="Select your Experience">Select your Experience</option>
      <option value="Fresher">Fresher</option>
      <option value="Professional">Professional</option>
      <option value="Advanced">Advanced</option>
      </select>
      </div>
      </div>

      <div className='col-lg-12'>
      <div className="mb-3">
      <label htmlFor="tellabout" className="form-label">Your message...</label>
      <textarea className="form-control" id="tellabout" rows="2"></textarea>
      </div>
      </div>

      <div className='col-lg-12'>
      <div className="mb-4">
      <label htmlFor="uploadcv" className="form-label">Upload Your CV here</label>
      <input className="form-control" type="file" id="uploadcv" />
      </div>
      </div>

      <div className='col-lg-12'>
      <button className='btn btn-primary btn-lg'>Submit</button>
      </div>


      </div>

      </div>

      </div>

      </div>


    </div>
    </div>


    </MainLayout>
    </>
  )
}
